import * as R from 'ramda';
import axios from 'axios';

const CampaignsApiClient = {
    async index() {
        const response = await axios.get('/api/campaigns/dropdown');
        return R.prop('data', response);
    }
};

export default CampaignsApiClient;



// WEBPACK FOOTER //
// ./campaigns_api_client/index.js